<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de motivo de viagem / procedimento">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'transporte-paciente-motivo-create' })"
                    autorize="store-transporte-paciente-motivo"
                    color="primary"
                >
                    Cadastrar motivo
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/motivo/List'

export default {
    components: { List },
}
</script>